































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { CourseListItem, Cache } from '@/common/cache';
import { User, Courses } from '@lantern/lantern-sdk';
import { Subscription } from 'vue-rx-decorators';

// @ts-ignore
import Datepicker from 'vuejs-datepicker';

enum SectionTitels {
    changeSection = 'Pick a Section',
    createSection = 'Create a Section'
}

@Component({
    components: {
        Datepicker
    },
})
export default class SectionComponent extends Vue {
    @Prop()
    show?: boolean; ;

    @Prop()
    params?: {course?: CourseListItem; create?: boolean}

    @Subscription(() => Cache.instance.accounts)
    accounts!: User.CanvasAccounts | { mainAccounts: []; subAcccounts: [] };

    modal: any = {
        section: {
            show: false,
            cancel: this.sectionCancel,
            submit: this.sectionSubmit,
            switchToSectionCreation: this.switchToSectionCreation,
            title: 'Section block',
            course: null as CourseListItem | null, // course to pick sections
            startDate: new Date(), // new section param
            endDate: new Date(), // new section param
            newSectionName: null as string | null, // new section param
            createNewSection: false, // switch between create section and pick section
            pickedSection: null as Courses.Section | null, // use for manual section pick
            required: false, // add required classes,
            loader: false
        }
    };

    async created() {};

    @Subscription(() => Cache.instance.accounts)
    coursesArray!: CourseListItem[] | [];

    // #region SECTIONS
    changeSection(course: CourseListItem) {

        this.modal.section.course = null;
        this.modal.section.createNewSection = false;
        this.modal.section.title = SectionTitels.changeSection;
        this.modal.section.show = true;
        this.modal.section.course = course;
    };

    createSection(course: CourseListItem) {
        this.modal.section.title = SectionTitels.createSection;
        this.modal.section.show = true;
        this.modal.section.createNewSection = true;
        this.modal.section.newSectionName = null;
        this.modal.section.course = course;
    }

    switchToSectionCreation() {
        this.modal.section.title = SectionTitels.createSection;
        this.modal.section.createNewSection = true;
    }

    sectionCancel() {

        // if were working with a new section creation
        if (this.modal.section.createNewSection) {

            this.modal.section.createNewSection = false;
            this.modal.section.startDate = new Date();
            this.modal.section.endDate = new Date();
            this.modal.section.newSectionName = null;
            this.modal.section.title = SectionTitels.changeSection;
            this.modal.section.show = false;

        } else { // we were working with section pick window

            // pick section by default
            this.modal.section.pickedSection = null;
            this.modal.section.show = false;
        }
        this.$emit('close');
    }

    async sectionSubmit() {

        // if we just created a new section
        if (this.modal.section.createNewSection) {

            // check all fields are filled
            if (!this.modal.section.newSectionName) {
                this.modal.section.required = true; return;
            }

            // create section on the server
            this.modal.section.loader = true;
            const response = await this.$lantern.endpoints.Courses.createSection({ name: this.modal.section.newSectionName, startAt: this.modal.section.startDate, endAt: this.modal.section.endDate }, { courseId: this.modal.section.course!.id.toString() });

            // pick the section as the main section for the course
            (this.modal.section.course!.sections as Courses.Section[]).push(response.data as Courses.Section);
          this.modal.section.course!.pickedSection = response.data;

          // show cource the list
          this.modal.section.show = false;
          this.modal.section.loader = false;

        } else { // we were working with section pick window

          // add selected section to pickedSection - so we know it'ы manually changed
          this.modal.section.course!.pickedSection = this.modal.section.pickedSection;
          this.modal.section.show = false;
        }
        this.$emit('close');

    }

    pickNewSection(value: any) {
        this.modal.section.pickedSection = value;
    }

    dateFormate(dateString: string) {
        if (!dateString) return 'none';
        const date = new Date(dateString);
        const dateTimeFormat = new Intl.DateTimeFormat('en', { year: 'numeric', month: 'short', day: '2-digit' });
        const [{ value: month },, { value: day },, { value: year }] = dateTimeFormat.formatToParts(date);

        return `${month}-${day}-${year}`;
    }

    // #endregion SECTIONS HENDLERS

    @Watch('params')
    onshowChanged(val: string, oldVal: string) {
        if (this.params?.create) {
            if (this.params) this.createSection(this.params.course as any);
        } else if (this.params) this.changeSection(this.params.course as any);

    }

}

